import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export function DmInlineError({ message }: { message: string }) {
    return (
        <p
            role="alert"
            className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[13px] text-red-800"
        >
            <ExclamationTriangleIcon className="h-4 w-4 shrink-0 mt-0.5 text-red-600" />
            {message}
        </p>
    );
}
